import GLOBAL from "../../../../global";
import Assessment from "../../../../models/Assessment";
import {
    ASSESSMENT_SAVE_URL,
    UPDATE_USER_URL,
    TELEMED_SESSION_KEY_URL,
    EXERCISE_GUIDELINE_ALL, WEBRTC_TOKEN_CREATION_URL, MEASURED_EXERCISES_URL,
} from './UrlManager';
import axios from '../../../../../src/services/Axios';
import ExamService from "../../../../services/ExamService";
import { error, success } from "../../../../services/ResponseHandler";
import ErrorLogService from "../../../../services/ErrorLogService";

const RESPONSE_TYPE = { responseType: 'text' };

const getNewAssessment = (providerEmail,testId,bodyRegionList) => {
    let assessment = new Assessment();
    assessment.ProviderEmail = providerEmail;
    assessment.TestId = (GLOBAL.ASSESSMENT && GLOBAL.ASSESSMENT['TestId']) || testId;
    assessment.BodyRegionList = bodyRegionList || [];
    assessment.InvitationId = GLOBAL.URL_PARAMS.INVITATION_ID;
    assessment.DemographicsCompleted = (GLOBAL.ASSESSMENT && GLOBAL.ASSESSMENT['DemographicsCompleted']) || false;
    assessment.ADLCompleted = (GLOBAL.ASSESSMENT && GLOBAL.ASSESSMENT['ADLCompleted']) || false;
    assessment.MedicalHistoryCompleted = (GLOBAL.ASSESSMENT && GLOBAL.ASSESSMENT['MedicalHistoryCompleted']) || false;
    assessment.ChiefComplaintsCompleted = (GLOBAL.ASSESSMENT && GLOBAL.ASSESSMENT['ChiefComplaintsCompleted']) || false;
    assessment.Results = [];
    assessment.Answers = [];

    return assessment;
};

const saveAssessments = async (payload) => {
    const errorPayload = ErrorLogService.createErrorLogPayload({
        Tenant: GLOBAL.TENANT || "Unknown_Tenant",
        Source: "AssessmentService",
        HelpLink: "",
        DeviceInfo: navigator.userAgent || "Unknown Device",
        RequestUrl: ASSESSMENT_SAVE_URL,
        TestId: payload.TestId,
        IncomingData: payload
    });

    try {
        const payloadToSend = { ...payload };
        delete payloadToSend.bodyRegionList;
        delete payloadToSend.BodyRegionList;
        delete payloadToSend.InvitationId;
        delete payloadToSend.PatientId;

        const response = await axios.post(ASSESSMENT_SAVE_URL, payloadToSend, RESPONSE_TYPE);

        // Check if response status is not 200 and log error
        if(response && response.status && response.status !== 200) {
            errorPayload.StackTrace = `HTTP ${response.status} - ${response.statusText || 'Unknown Error'}`;
            errorPayload.Message = `Get exercise list failed with status ${response.status}`;

            await ErrorLogService.logError(errorPayload, { fireAndForget: true });
        }

        return success(response)?.success;
    } catch (e) {
        // Log error for axios network errors or other exceptions
        errorPayload.StackTrace = e.stack || e.toString();
        errorPayload.Message = `Video processing failed: ${e.message || 'Unknown error'}`;

        await ErrorLogService.logError(errorPayload, { fireAndForget: true });

        error(e);
        return false;
    }
}

export const savePainQuestions = async (painQuestionList, providerEmail, testId, bodyRegionList) => {
    if(painQuestionList && painQuestionList.length > 0){
        let assessment = getNewAssessment(providerEmail,testId,bodyRegionList);

        for(let painQuestion of painQuestionList){
            let answer = {};
            answer.AnswerId = painQuestion.AnswerId;
            answer.QuestionId = painQuestion.QuestionId;
            answer.AnswerList = painQuestion.AnswerList;

            assessment.Answers.push(answer);
        }
        let response = await saveAssessments(assessment);
        return response;
    }
    return true;
}

export const saveSkipReasonQuestions = async (skipReasonAnswer, providerEmail, testId, bodyRegionList) => {
    if (skipReasonAnswer) {
        let assessment = getNewAssessment(providerEmail, testId, bodyRegionList);
        assessment.Answers.push(skipReasonAnswer);
        let response = await saveAssessments(assessment);
        return response;
    }
    return true;
}


export const updateUserData = async (userPayload) => {
    if(userPayload && Object.keys(userPayload).length > 0){
        try {
            const response = await axios.post(UPDATE_USER_URL, userPayload, RESPONSE_TYPE);
        } catch (e) {
            console.error("Exception issue in patient update");
            error(e);
        }
    }
    return;
}

export const skipMovement = async (exercsieList, exercise,providerEmail,testId) => {
    if(exercise && exercsieList && exercsieList.length > 0){

        let payload = {
            TestId: testId,
            ExerciseValue: exercise?.ExerciseCodeName,
            IsUnableToPerformedExercise: true
        };
        let response = await ExamService.skipAMovement(payload);
        return response;
    }
    return true;
}

export const getTelemedSessionId = async (invitationId) => {

    const payload = {
        InvitationId: invitationId
    };

    try {
        const response = await axios.post(TELEMED_SESSION_KEY_URL, payload, RESPONSE_TYPE);

        if(response){
            if(response && response?.StatusMessage === 'Success'){
                return success(response);
            }
        }
        else {
            return {
                success: false,
                error: "No response found"
            }
        }
    } catch (e) {
        error(e);
        return {
            success: false,
            error: "Request failed"
        };
    }
}

export const createWebRTCToken = async (invitationId) => {

    const payload = {
        InvitationId: invitationId
    };

    try {
        const response = await axios.post(WEBRTC_TOKEN_CREATION_URL, payload, RESPONSE_TYPE);

        if(response){
            if(response && response?.StatusCode === 200){
                return success(response);
            }
        }
        else {
            return error({
                success: false,
                error: "No response found"
            })
        }
    } catch (e) {
        error(e);
    }
}

export const getAllExerciseGuideline = async () => {
    const payload = {

    };

    try {
        const response = await axios.post(EXERCISE_GUIDELINE_ALL, payload, RESPONSE_TYPE);
        return success(response);
    } catch (e) {
        return error(e);
    }
}
